import { MARKER_VARIANT, BADGE_VARIANT, NOTES_OVERRIDE_COLOR_VARIANT, SHADOW_STYLE_VARIANT } from "./variants";
import { ColorParams } from "../types";

/**
 * Dimmed icons coloring
 * Adds opacity to the icon to make it appear dimmed (not disabled)
 */
export const dimmedIconStyles = {
    opacity: 0.6,
    filter: "brightness(0.6)",
};

/**
 * Defines styles for each marker variant
 */
export const markerVariantStyleMapping: Record<MARKER_VARIANT, ColorParams> = {
    [MARKER_VARIANT.SENSOR]: {
        shadow: "#819423",
        iconBackground: "#BBD050",
        border: "#6A7A1D",
        shadowStyle: SHADOW_STYLE_VARIANT.DENSE,
        iconColor: "#000000",
    },
    [MARKER_VARIANT.VALVE]: {
        shadow: "#B1B0B0",
        iconBackground: "#F1EFEF",
        border: "#BBBABA",
        shadowStyle: SHADOW_STYLE_VARIANT.SPARSE,
        iconColor: "#000000",
    },
    [MARKER_VARIANT.GROUP]: {
        shadow: "#B1B0B0",
        iconBackground: "#FDFDFD",
        shadowStyle: SHADOW_STYLE_VARIANT.SPARSE,
        iconColor: "#000000",
    },
    [MARKER_VARIANT.DRAGINO_GATEWAY]: {
        shadow: "#C47FFF",
        iconBackground: "#DBB1FF",
        border: "#C47FFF",
        shadowStyle: SHADOW_STYLE_VARIANT.DENSE,
        iconColor: "#000000",
    },
} as const;

/**
 * Defines colors that can be overridden by the notes field
 * TODO: color via notes is included to support legacy setups and will be replaced with a proper system for custom icon colors. ref: SWD-595
 */
export const notesColorMapping: Record<NOTES_OVERRIDE_COLOR_VARIANT, ColorParams> = {
    [NOTES_OVERRIDE_COLOR_VARIANT.BLUE]: {
        shadow: "#1A5AAD",
        iconBackground: "#4A90E2",
        border: "#3A7BCE",
    },
    [NOTES_OVERRIDE_COLOR_VARIANT.TEAL]: {
        shadow: "#008C76",
        iconBackground: "#00BFA5",
        border: "#00A68E",
    },
    [NOTES_OVERRIDE_COLOR_VARIANT.YELLOW]: {
        shadow: "#B7950B",
        iconBackground: "#F1C40F",
        border: "#D4AC0D",
    },
    [NOTES_OVERRIDE_COLOR_VARIANT.PURPLE]: {
        shadow: "#7B1FA2",
        iconBackground: "#9C27B0",
        border: "#8E24AA",
    },
    [NOTES_OVERRIDE_COLOR_VARIANT.PINK]: {
        shadow: "#C2185B",
        iconBackground: "#EC407A",
        border: "#D81B60",
    },
    [NOTES_OVERRIDE_COLOR_VARIANT.BROWN]: {
        shadow: "#5D4037",
        iconBackground: "#795548",
        border: "#6D4C41",
    },
    [NOTES_OVERRIDE_COLOR_VARIANT.INDIGO]: {
        shadow: "#283593",
        iconBackground: "#5C6BC0",
        border: "#3F51B5",
    },
};

/**
 * Disabled icons coloring
 * Uses a semi-transparent gray to indicate a disabled state
 */
export const disabledIconColorMapping: ColorParams = {
    shadow: "#B1B0B0",
    iconBackground: "#BBBABA",
    border: "#BBBABA",
    shadowStyle: SHADOW_STYLE_VARIANT.SPARSE,
    iconColor: "#8D8D8D",
};

/**
 * Defines colors for each badge variant
 */
export const badgeColorMapping: Record<BADGE_VARIANT, { bg: string; border: string }> = {
    [BADGE_VARIANT.ERROR]: {
        bg: "#F04438",
        border: "#FDFDFD",
    },
    [BADGE_VARIANT.WARNING]: {
        bg: "#F79009",
        border: "#FDFDFD",
    },
} as const;
